import { Injectable } from '@angular/core';

import { Trend } from './trend';
import { TRENDS } from './trends';
import { MOCKTRENDS } from './mock-trends';

@Injectable()
export class TrendsService {

  getTrends(): Promise<Trend[]> {
    return Promise.resolve(TRENDS);
  }

  getMockTrends(): Promise<Trend[]> {
    return Promise.resolve(MOCKTRENDS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/trends/trends/trends.service.ts